import React from 'react';

export function LoadingIcon() {
  return (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M9 0a9 9 0 110 18A9 9 0 019 0zm0 2a7 7 0 100 14A7 7 0 009 2z"
          id="loading"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="smallLoading" fill="#fff">
          <use href="#loading" />
        </mask>
        <use fill="#D8E3E9" fillRule="nonzero" href="#loading" />
        <g mask="url(#smallLoading)" fill="#0C60A5">
          <g transform="translate(-3 -3)">
            <path d="M0 0h12v12H0z" />
            <circle cx="12" cy="4" r="1" />
            <circle cx="4" cy="12" r="1" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function LargeLoadingIcon() {
  return (
    <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M28 0c15.464 0 28 12.536 28 28S43.464 56 28 56 0 43.464 0 28 12.536 0 28 0zm0 4C14.745 4 4 14.745 4 28s10.745 24 24 24 24-10.745 24-24S41.255 4 28 4z"
          id="largeLoading"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <mask id="meijerLoading" fill="#fff">
            <use href="#largeLoading" />
          </mask>
          <use fill="#D8E3E9" fillRule="nonzero" href="#largeLoading" />
          <g mask="url(#meijerLoading)" fill="#0C60A5">
            <g transform="translate(-4 -4)">
              <path d="M0 0h32v32H0z" />
              <circle cx="32" cy="6" r="2" />
              <circle cx="6" cy="32" r="2" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function MeijerIcon() {
  return (
    <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.336 17.366h5.443v2.855c.976-2.147 2.64-3.221 4.987-3.221 2.443 0 3.923 1.074 4.438 3.221.934-2.147 2.62-3.221 5.055-3.221 1.359 0 2.444.244 3.249.734.804.49 1.364 1.16 1.681 2.009.316.85.475 2.449.475 4.801V38h-5.757V25.131c0-1.536-.112-2.535-.335-2.997-.222-.463-.715-.695-1.481-.695-.92 0-1.519.303-1.796.908-.279.607-.416 1.827-.416 3.662V38h-5.757V24.947c0-1.468-.106-2.42-.315-2.854-.21-.435-.685-.654-1.427-.654-.92 0-1.53.318-1.833.95-.303.632-.455 1.839-.455 3.62V38h-5.756V17.366z"
          fill="#DB232D"
        />
      </g>
    </svg>
  );
}
